$(document).on('click', '[data-accordion-title]', function (event) {
  event.preventDefault();
  const $container = $(this).closest('[data-accordions-container]');

  if ($container.data('accordions-mobile-only') == "1" && $(window).outerWidth() > 989 ) {
    return false;
  }

  const $currentBtn = $(this);
  const $currentContent = $(this).siblings('[data-subaccordion]');
  $currentBtn.toggleClass('is-open');
  $currentContent.slideToggle();
  $('[data-accordion-title]', $container).not($currentBtn).removeClass('is-open');
  $('[data-subaccordion]', $container).not($currentContent).slideUp();
});

$(document).on('click', '[data-accordion-subtitle]', function (event) {
  event.preventDefault();
  const $container = $(this).closest('[data-accordions-container]');

  if ($container.data('accordions-mobile-only') == "1" && $(window).outerWidth() > 989 ) {
    return false;
  }

  const $currentBtn = $(this);
  const $currentContent = $(this).siblings('[data-accordion-content]');
  const $currentItem = $(this).closest('[data-subaccordion]');
  $currentBtn.toggleClass('is-open');
  $currentContent.slideToggle();
  $currentItem.toggleClass('faq-open_background');
  $('[data-accordion-subtitle]', $container).not($currentBtn).removeClass('is-open');
  $('[data-accordion-content]', $container).not($currentContent).slideUp();
  $('[data-subaccordion]', $container).not($currentItem).removeClass('faq-open_background');
});

$(document).ready(function(){
  $('.sf__pcard-content .box').matchHeight({
   byRow: true,
   });
});